import {FunctionComponent} from "react";
import "./index.scss";
import {Collapse} from 'antd';
import {useProcessDocumentController} from "./controller";
import CollapsePanel from "antd/lib/collapse/CollapsePanel";
import {CaretRightOutlined} from "@ant-design/icons/lib/icons";


export const ProcessDocument: FunctionComponent = () => {
  const controller = useProcessDocumentController();

  return (
    <div className="process-document">
      <Collapse
        bordered={false}
        defaultActiveKey={controller.defaultActiveKey}
        expandIcon={({isActive}) => (
          <CaretRightOutlined
            rotate={isActive ? 90 : 0}
            style={{color: "#5F9FAB", fontSize: "1rem"}}
          />
        )}
        expandIconPosition={"right"}
      >
        <CollapsePanel key={"business-teams"} header={"Business Teams"}>
          {Object.keys(controller.businessTeamCreationContent).map((key) => (
            <>
              <h4>{key}</h4>
              {controller.businessTeamCreationContent[key]}
            </>
          ))}
        </CollapsePanel>
        <CollapsePanel key={"access-review-for-itgc"} header={"Access Review For ITGC"}>
          {Object.keys(controller.accessReviewProcessForItgc).map((key) => (
            <>
              <h4>{key}</h4>
              {controller.accessReviewProcessForItgc[key]}
            </>
          ))}
        </CollapsePanel>
        <CollapsePanel key={"access-review-for-non-itgc"} header={"Access Review For Non-ITGC"}>
          {Object.keys(controller.accessReviewProcessForNonItgc).map((key) => (
            <>
              <h4>{key}</h4>
              {controller.accessReviewProcessForNonItgc[key]}
            </>
          ))}
        </CollapsePanel>
      </Collapse>
    </div>
  );
};

